import type { Tables } from '~/types/database-helpers';
import { type User } from '@supabase/gotrue-js/src';
import { TeamsService } from '~/lib/services/teams.service';

export type Team = Tables<'teams'>;
export const useTeamsStore = defineStore('teams', {
  state: (): {
    teams: Team[];
    total: number;
    pageCount: number;
  } => ({
    teams: [],
    total: 0,
    pageCount: 0,
  }),
  actions: {
    setTotal(total: number) {
      this.total = total;
    },
    setPageCount(count: number) {
      this.pageCount = count;
    },
    async fetchTeams(): Promise<Team[] | null> {
      try {
        const supabase = useSupabaseClient();
        const teamsService = new TeamsService(supabase);
        const { data } = await teamsService.findAll({
          perPage: 4000,
          sort: { field: 'name', ascending: true },
        });
        if (data) {
          this.setTeams(data);
        }
        return data;
      } catch (error: any) {
        console.error(error);
        return null;
      }
    },
    setTeams(teams: Team[]) {
      this.teams = teams;
    },
  },
});
